import { h, render } from 'preact'
import { Carrousel } from '../../components/carrousel/carrousel.jsx'
import styles from '../../scss/shadowStyles.scss'
import fontIcon from '../../fonts/icon-orange.woff2'
import fontHelvetica55 from '../../fonts/HelvNeue55_W1G.woff2'
import fontHelvetica75 from '../../fonts/HelvNeue75_W1G.woff2'
var isSmartphone = require('is-mobile')

import { SG1Logs } from '../modules/logs.js'



export const carrouselOrchestrator = (data, shadowDOM) => {
   try {
      if (data.zones[0].data.slides.length === 0) throw ('Pas de bannieres dans les données')
      let format = getFormat(dataStoreHP.pageId, isSmartphone() ? 'mobile' : 'desktop')
      let target = document.getElementById('carrousel')
      if (shadowDOM) {
         //import des fonts
         importFonts()

         //injection du shadowDOM
         target = target.attachShadow({ mode: "open" })
         const style = document.createElement('style')
         style.textContent = styles
         target.appendChild(style)
      }

      render(<Carrousel slides={data.zones[0].data.slides} format={format} DOMtarget={target} />, target)

   } catch (error) {
      console.error('Carrousel orchestrator', error)
      SG1Logs.incLog('Err_CORCH')
   }
}

const getFormat = (pageId, deviceType) => {
   let format = ''
   switch (pageId) {
      case 'hp-regulier':
         format = 'regulier'
         break
      case 'hp-occasionnel':
         format = 'occasionnel'
         break
      case 'hp-prospect':
         format = 'prospect'
         break
      case 'vitrine-boutique':
      case 'vitrine-boutique-client':
         format = 'boutique'
         break
      case 'n1-forfaits-prospect':
      case 'n1-forfaits':
      case 'shop':
         format = 'mobile'
         break
      case 'n1-tv-prospect':
      case 'n1-tv':
         format = 'tv'
         break
   }
   return deviceType === 'mobile' ? `${format}-mobile` : format
}

const importFonts = () => {
   //injection d'une balise <style> avec le css de la font
   const fontStyle = document.createElement('style')
   fontStyle.textContent = `
      @font-face {
         font-family: 'icon-orange';
         src: url(${fontIcon}) format('woff2');
         font-weight: 400;
         font-style: normal;
         font-display: block;
      }

      @font-face{
         font-family:"o-HelveticaNeue";
         src:url(${fontHelvetica55}) format("woff2");
         font-weight:normal;
         font-style:normal;
         font-display:swap
       }
      
      @font-face{
         font-family: "o-HelveticaNeue";
         src: url(${fontHelvetica75}) format("woff2");
         font-weight: bold;
         font-style: normal;
         font-display: swap
      }
   `
   document.head.appendChild(fontStyle)
}